@let readOnly = type() != cardTypes.DEFAULT ? true : false;
@let currentField = getCurrentField();
<!-- Grid resolvido por hierarquia: override do card ?? config do documento ?? default. -->
@let currentGrid = currentField.configs?.groupImageGrid ?? editDataService.document()?.config?.groupImageGrid ?? 2;

<card-base 
    [field]="field()" 
    [favoriteField]="favoriteField()" 
    [trashField]="trashField()" 
    [type]="type()"
    [selected]="selected()" 
    [dynamicActions]="imageActions"
    [overflowTitle]="'document.edit.railLook.grid' | translate">

    <!-- Zona 1 do rail: "Grade" (fotos por linha, enquadramento, número e data). O
         "Adicionar fotos" vem das ações primárias. Só no editor. -->
    @if (!readOnly) {
        <media-look-chip
            card-toolbar
            kind="group"
            [itemId]="currentField?._id"
            [columns]="currentGrid"
            [fullImage]="isFullImage()"
            [fillColor]="fillColor()"
            [showNumber]="showImageNumber()"
            [showDate]="showImageDate()"
            [captionStyle]="captionStyle()"
            [canRestore]="lookOverridden()"
            [disabled]="editDataService.documentIsBlocked()"
            (chooseColumns)="setColumns($event)"
            (captionStyleChange)="setCaptionStyle($event)"
            (fullImageChange)="setLook('fullImage', $event)"
            (fillPreview)="previewFill($event)"
            (fillColorChange)="setFill($event)"
            (showNumberChange)="setLook('showImageNumber', $event)"
            (showDateChange)="setLook('showImageDate', $event)"
            (restore)="restoreLook()"
        />
    }

    <!-- Fotos e legenda: o estilo da legenda espelha a folha do PDF (config captionStyle). -->
    <div
        class="media-figure group"
        [class.style-figure]="captionStyle() === 'figure'"
        [class.style-band]="captionStyle() === 'band'">
        <div class="media-body">
            <div 
                class="container-images"
                [style.--media-fill]="fillStyle()"
                [class.grid-1-column]="currentGrid === 1"
                [class.grid-2-columns]="currentGrid === 2"
                [class.grid-3-columns]="currentGrid === 3">
                @for (image of currentField.value; track image.url; let index = $index) 
                {
                    <div class="container-individual-image">

                        <img [src]="image.url" (click)="openFullScreen(index)" />

                        <!-- Número/data da foto (mesma config do preview e do PDF) -->
                        @if ((showImageNumber() && firstImageNumber() !== null) || (showImageDate() && image.date)) {
                            <div class="image-meta">
                                @if (showImageNumber() && firstImageNumber() !== null) {
                                    <p class="ra-label-xs bold">{{ 'document.preview.imageData.numberLabel' | translate: { num: (firstImageNumber()! + index | number:'3.0-0') } }}</p>
                                }
                                @if (showImageDate() && image.date) {
                                    <p class="ra-label-xs bold">{{ image.date | date:'shortDate' }}</p>
                                }
                            </div>
                        }

                        <!-- Icon actions -->
                        @if (!readOnly) 
                        {
                            <div class="container-individual-actions">

                                <!-- Trocar imagem -->
                                <ra-square-icon 
                                    [icon]="'arrow-swap-horizontal'" 
                                    [tooltip]="('document.edit.groupImageCard.swapImage' | translate)" 
                                    [size]="25"
                                    (click)="changeIndividualImage(index)" 
                                />

                                <!-- Editar imagem -->
                                <ra-square-icon 
                                    [icon]="'edit-2'" 
                                    [tooltip]="('document.edit.groupImageCard.editImage' | translate)" 
                                    [size]="25"
                                    (click)="editIndividualImage(index)" 
                                />

                                <!-- Data da imagem -->
                                <ra-square-icon 
                                    [icon]="'calendar'" 
                                    [tooltip]="('document.edit.groupImageCard.changeDate' | translate)" 
                                    [size]="25"
                                    (click)="dateModalIndex.set(index)" 
                                />

                                <!-- Remover imagem -->
                                <ra-square-icon 
                                    [icon]="'trash'" 
                                    [tooltip]="('document.edit.groupImageCard.removeImage' | translate)" 
                                    [type]="'danger'" 
                                    [size]="25"
                                    (click)="removeIndividualImage(index)"
                                />
                            </div>
                        }
                    </div>
                }
            </div>
        </div>

        <div class="media-caption">
            <!-- Description -->
            <card-description-area [field]="currentField" [readonly]="type() !== 'default'" />
        </div>
    </div>
</card-base>

<!-- Image Editor Component -->
@if (showEditImage()) 
{
    <ra-edit-image 
        [imageUrl]="getImageUrlByPosition()" 
        (close)="showEditImage.set(false)"
        (imageSaved)="onImagesSaved($event)" 
    />
}

<!-- Tela cheia: galeria com todas as imagens da seção, começando na clicada -->
@if (showFullScreen())
{
    <ra-images-full-screen
        [images]="galleryImages()"
        [initialIndex]="fullScreenIndex()"
        (close)="showFullScreen.set(false)"
    />
}

<!-- Data de uma foto do grupo (paridade com o app) -->
@if (dateModalIndex() !== null)
{
    <modal-image-date
        [date]="groupEntryDate(dateModalIndex()!)"
        (save)="onSaveImageDate($event)"
        (close)="dateModalIndex.set(null)"
    />
}

